import React from 'react'
import { Col } from 'react-bootstrap';
import { CompanyProspectsInfo } from './CompanyProspectsInfo';
import { CompanyInformationPanel } from './CompanyInformationPanel';
import { CompanyPrimaryInfo } from './CompanyPrimaryInfo';


// currentCompanyId = allCompanies[nextPrevious].id

export const LeftSideCompanyDetails = ({
    companyData,
    companyId,
    parsedUserEmail,
    parsedUserPhone,
    // currentCompanyId,
    contactDetails,
    fetchCompanyDetails
}) => {

    return (
        <Col
            md={8}
            className="ps-4 contactInformation"
            style={{ height: "96%", paddingRight: 1, overflow: "auto" }}
        >
            {/* primary company information */}
            <CompanyPrimaryInfo
                companyData={companyData}
            />
            {/* leads and deals info */}
            <CompanyProspectsInfo
                companyData={companyData}
                companyId={companyId}
                fetchCompanyDetails={fetchCompanyDetails}
                contactDetails={contactDetails}
            // currentCompanyId={currentCompanyId}
            />


            {/* detailed company information */}
            <CompanyInformationPanel
                companyData={companyData}
                parsedUserEmail={parsedUserEmail}
                parsedUserPhone={parsedUserPhone}
            />
        </Col>

    )
}